import dayjs from "dayjs";
import { Coach } from "../entity/Coach";

export interface CoachValidationObj {
  firstName: boolean;
  lastName: boolean;
  gender: boolean;
  birthDate: boolean;
  address: boolean;
  email: boolean;
  phone: boolean;
  nationalId: boolean;
  note: boolean;
  nickname: boolean;
  wage: boolean;
  tax: boolean;
  accountNumber: boolean;
}

export const coachValidationObjInit = {
  firstName: true,
  lastName: true,
  gender: true,
  birthDate: true,
  address: true,
  email: true,
  phone: true,
  nationalId: true,
  note: true,
  nickname: true,
  wage: true,
  tax: true,
  accountNumber: true,
};

export const validateCoach = (c: Coach): CoachValidationObj => {
  const parsedWage = parseFloat(c.wage.toString());
  const parsedTax = parseFloat(c.tax.toString());
  return {
    firstName: c.firstName.length > 0,
    lastName: c.lastName.length > 0,
    gender: c.gender !== "",
    birthDate: dayjs(c.birthDate, "YYYY-MM-DD", true).isValid(),
    address: c.address.length > 0,
    email: c.email.length > 0,
    phone: c.phone.length > 0,
    nationalId: true,
    note: true,
    nickname: c.nickname.length > 0,
    wage: Number.isInteger(parsedWage) && c.wage >= 0,
    tax: Number.isInteger(parsedTax) && c.tax >= 0 && c.tax <= 100,
    accountNumber: c.accountNumber.length > 0,
  };
};
